import { Config } from '@/config';
import BaseAuthApiService from '@/api/base-auth-api-service';
import { OrderReceiptRawModel } from '@/api/api-raw-models/order-receipt-raw-model';
import { OrderReceiptModel } from '@/models/OrderReceiptModel';
import { mapOrderReceipt } from '@/api/mappers/map-response/map-order';
import { CurbsideModel } from '@/models/CurbsideModel';
import { mapCurbsideRequest } from '@/api/mappers/map-request';
import { CurbsideRequestRawModel } from '@/api/api-raw-models/curbside-request-raw-model';

export class OrderApiService extends BaseAuthApiService {
  private readonly orderPrefix = 'orders';

  public async receipt(orderId: number): Promise<OrderReceiptModel> {
    const url = `${Config.ApiUrl}/${this.orderPrefix}/receipt`;

    const res = await this.authorizedRequest(url, {
      method: 'POST',
      body: JSON.stringify({
        // eslint-disable-next-line @typescript-eslint/camelcase
        order_id: orderId,
      }),
    });

    return this.mapResponse<OrderReceiptRawModel, OrderReceiptModel>(res, mapOrderReceipt);
  }

  public async curbsidePickup(orderId: number, data: CurbsideModel): Promise<void> {
    const url = `${Config.ApiUrl}/${this.orderPrefix}/${orderId}`;

    await this.authorizedRequest(url, {
      method: 'PUT',
      body: JSON.stringify(
        this.mapRequest<CurbsideModel, CurbsideRequestRawModel>(data, mapCurbsideRequest),
      ),
    });
  }
}
